var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 360 360",
    style: {
      enableBackground: "new 0 0 360 360"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.est0{fill-rule:evenodd;clip-rule:evenodd;fill:none;}\r\n\t.est1{fill-rule:evenodd;clip-rule:evenodd;fill:currentColor;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -0.53,
    className: "est0",
    width: 360,
    height: 360
  }), /*#__PURE__*/React.createElement("path", {
    className: "est1",
    d: "M220.95,332.09v22.05c0,1.88-0.65,3.49-1.7,4.57c-0.76,0.79-1.76,1.29-2.82,1.29h-67.01 c-1.04,0-2.04-0.5-2.82-1.29l-0.01,0.01c-1.04-1.09-1.7-2.7-1.7-4.57v-22.05h-21.29c-1.81,0-3.55-0.79-4.87-2.07 c-1.79-1.71-2.9-4.26-2.9-7.22v-29.19H97.77c-1.82,0-3.55-0.79-4.87-2.06c-1.79-1.71-2.91-4.26-2.91-7.22V100.36H68.22 c-2.66,0-5.08-1.04-6.84-2.72c-1.75-1.68-2.84-4-2.84-6.56V9.28c0-2.56,1.09-4.88,2.84-6.57C63.14,1.04,65.56,0,68.22,0h222.48 c2.68,0,5.09,1.04,6.85,2.71c1.75,1.69,2.84,4.01,2.84,6.57v81.81c0,2.56-1.09,4.88-2.84,6.56c-1.76,1.68-4.17,2.72-6.85,2.72 h-21.77v183.97c0,2.96-1.1,5.51-2.89,7.22c-1.32,1.27-3.05,2.06-4.87,2.06h-14.85v29.19c0,2.96-1.11,5.52-2.89,7.22 c-1.33,1.27-3.06,2.07-4.87,2.07H220.95L220.95,332.09z M234.17,25.75c-3.56,0-6.46,2.78-6.46,6.19v38.92 c0,3.4,2.91,6.19,6.46,6.19l0,0c3.56,0,6.46-2.78,6.46-6.19V31.94C240.63,28.53,237.73,25.75,234.17,25.75L234.17,25.75 L234.17,25.75z M180.63,25.75c-3.56,0-6.47,2.78-6.47,6.19v38.92c0,3.4,2.91,6.19,6.47,6.19l0,0c3.55,0,6.45-2.78,6.45-6.19V31.94 C187.08,28.53,184.18,25.75,180.63,25.75L180.63,25.75L180.63,25.75z M127.77,25.75c-3.55,0-6.45,2.78-6.45,6.19v38.92 c0,3.4,2.91,6.19,6.45,6.19l0,0c3.56,0,6.46-2.78,6.46-6.19V31.94C134.23,28.53,131.33,25.75,127.77,25.75L127.77,25.75 L127.77,25.75z M97.77,86.23h163.4h24.47v-72.1H73.31v72.1H97.77L97.77,86.23z M258.02,279.48V100.36H100.92v179.12 C153.13,279.48,205.83,279.48,258.02,279.48L258.02,279.48z M235.4,293.61H126.77v27.76H235.4V293.61L235.4,293.61z M213.7,331.81 h-61.53v21.48h61.53V331.81z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanner);
export default __webpack_public_path__ + "static/media/scanner.3f4cfd81a0d76614a33fe2f3c8f68b4e.svg";
export { ForwardRef as ReactComponent };